// ===========================================
// Export Buttons Component
// ===========================================
// Button group for exporting reports as CSV or PDF

import { ButtonGroup, Button, CircularProgress } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';

import { ReportExportFormat } from '../../api/reports.api';

// ===========================================
// TYPES
// ===========================================

interface ExportButtonsProps {
  onExport: (format: ReportExportFormat) => void;
  loading?: boolean;
  disabled?: boolean;
}

// ===========================================
// COMPONENT
// ===========================================

export default function ExportButtons({
  onExport,
  loading = false,
  disabled = false,
}: ExportButtonsProps) {
  return (
    <ButtonGroup variant="outlined" disabled={disabled || loading}>
      <Button
        startIcon={loading ? <CircularProgress size={16} /> : <DownloadIcon />}
        onClick={() => onExport('csv')}
      >
        Export CSV
      </Button>
      <Button
        startIcon={loading ? <CircularProgress size={16} /> : <DownloadIcon />}
        onClick={() => onExport('pdf')}
      >
        Export PDF
      </Button>
    </ButtonGroup>
  );
}
